import { render, staticRenderFns } from "./TabDuties.vue?vue&type=template&id=4e7f49d4"
import script from "./TabDuties.vue?vue&type=script&lang=ts"
export * from "./TabDuties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports